export default "__VITE_ASSET__qH4o72kd__"